import { useEffect, useState } from 'react'
import { LATEST_BUILD_URL, MAC_BUILD } from '@/lib/landing'

interface LatestBuild {
  file: string
  size: string
  version: string | null
}

const FALLBACK: LatestBuild = { file: MAC_BUILD.file, size: MAC_BUILD.size, version: null }
let cached: LatestBuild | null = null

const formatSize = (bytes: number) => `${Math.round(bytes / 1_000_000)} MB`

/**
 * The current desktop build, read from genie.art/download/latest.json so the
 * file name and size on the page track releases without a landing rebuild.
 * Falls back to the constants in lib/landing while loading or if the fetch
 * fails (offline, ad blocker, dev server).
 */
export function useLatestBuild(): LatestBuild {
  const [build, setBuild] = useState<LatestBuild>(cached ?? FALLBACK)
  useEffect(() => {
    if (cached) return
    let alive = true
    fetch(LATEST_BUILD_URL, { cache: 'no-cache' })
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error(String(r.status)))))
      .then((d: { version?: string; file?: string; size?: number }) => {
        if (!alive || typeof d.file !== 'string' || typeof d.size !== 'number') return
        cached = { file: d.file, size: formatSize(d.size), version: typeof d.version === 'string' ? d.version : null }
        setBuild(cached)
      })
      .catch(() => {})
    return () => {
      alive = false
    }
  }, [])
  return build
}
